import { render, staticRenderFns } from "./CaseExhibits.vue?vue&type=template&id=bce99496"
import script from "./CaseExhibits.vue?vue&type=script&lang=js"
export * from "./CaseExhibits.vue?vue&type=script&lang=js"
import style0 from "./CaseExhibits.vue?vue&type=style&index=0&id=bce99496&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports